import { makeStyles, shorthands } from '@fluentui/react-components';

export const headerSideBarStyles = makeStyles({
  root: {
    ...shorthands.borderLeft('1px', 'solid', 'var(--colorCompoundBrandStroke)'),
  },
});
